var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",style:({ transform: 'scale('+_vm.scale+')'})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.active},on:{"change":_vm.handleCheck}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }